import Api from '../../api'
import { captureFetchException } from '../../common/helpers'

// noinspection JSUnusedGlobalSymbols
export default (elements: NodeListOf<HTMLDivElement>) => {
  elements.forEach((element) => {
    const button = element.querySelector<HTMLButtonElement>('[data-hide-friends-button]')
    if (!button) {
      return
    }
    button.addEventListener('click', async () => {
      element.style.display = 'none'
      await Api.get({ url: 'user/hide-friends-block' })
        .catch((e) => {
          captureFetchException(e)
        })
    })
  })
}
